(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@angular/core'), require('@angular/common'), require('@angular/cdk/coercion'), require('@angular/cdk/platform'), require('rxjs'), require('rxjs/operators'), require('@shraddhar/web/base'), require('@angular/cdk/keycodes'), require('@material/ripple'), require('@shraddhar/web/ripple'), require('@shraddhar/web/dom'), require('@material/list')) :
    typeof define === 'function' && define.amd ? define('@shraddhar/web/list', ['exports', '@angular/core', '@angular/common', '@angular/cdk/coercion', '@angular/cdk/platform', 'rxjs', 'rxjs/operators', '@shraddhar/web/base', '@angular/cdk/keycodes', '@material/ripple', '@shraddhar/web/ripple', '@shraddhar/web/dom', '@material/list'], factory) :
    (global = global || self, factory((global.shraddhar = global.shraddhar || {}, global.shraddhar.web = global.shraddhar.web || {}, global.shraddhar.web.list = {}), global.ng.core, global.ng.common, global.ng.cdk.coercion, global.ng.cdk.platform, global.rxjs, global.rxjs.operators, global.ng.web.base, global.ng.cdk.keycodes, global.mdc.ripple, global.ng.web.ripple, global.ng.web.dom, global.mdc.list));
}(this, (function (exports, core, common, coercion, platform, rxjs, operators, base, keycodes, ripple, ripple$1, dom, list) { 'use strict';

    var MdcListDivider = /** @class */ (function () {
        function MdcListDivider(elementRef) {
            this.elementRef = elementRef;
            this._inset = false;
            this._padded = false;
        }
        Object.defineProperty(MdcListDivider.prototype, "inset", {
            get: function () {
                return this._inset;
            },
            set: function (value) {
                this._inset = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcListDivider.prototype, "padded", {
            get: function () {
                return this._padded;
            },
            set: function (value) {
                this._padded = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        MdcListDivider.decorators = [
            { type: core.Component, args: [{
                        selector: '[mdcListDivider], mdc-list-divider',
                        exportAs: 'mdcListDivider',
                        host: {
                            'role': 'separator',
                            'class': 'mdc-list-divider',
                            '[class.mdc-list-divider--inset]': 'inset',
                            '[class.mdc-list-divider--padded]': 'padded'
                        },
                        template: '',
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush
                    }] }
        ];
        /** @nocollapse */
        MdcListDivider.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        MdcListDivider.propDecorators = {
            inset: [{ type: core.Input }],
            padded: [{ type: core.Input }]
        };
        return MdcListDivider;
    }());

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __rest(s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    }

    function __decorate(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    }

    function __param(paramIndex, decorator) {
        return function (target, key) { decorator(target, key, paramIndex); }
    }

    function __metadata(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
    }

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __exportStar(m, exports) {
        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }

    function __values(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function () {
                if (o && i >= o.length) o = void 0;
                return { value: o && o[i++], done: !o };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }

    function __read(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        }
        catch (error) { e = { error: error }; }
        finally {
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            }
            finally { if (e) throw e.error; }
        }
        return ar;
    }

    function __spread() {
        for (var ar = [], i = 0; i < arguments.length; i++)
            ar = ar.concat(__read(arguments[i]));
        return ar;
    }

    function __spreadArrays() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    };

    function __await(v) {
        return this instanceof __await ? (this.v = v, this) : new __await(v);
    }

    function __asyncGenerator(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i, q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
        function fulfill(value) { resume("next", value); }
        function reject(value) { resume("throw", value); }
        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
    }

    function __asyncDelegator(o) {
        var i, p;
        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
    }

    function __asyncValues(o) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var m = o[Symbol.asyncIterator], i;
        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
    }

    function __makeTemplateObject(cooked, raw) {
        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
        return cooked;
    };

    function __importStar(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
        result.default = mod;
        return result;
    }

    function __importDefault(mod) {
        return (mod && mod.__esModule) ? mod : { default: mod };
    }

    function __classPrivateFieldGet(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
    }

    function __classPrivateFieldSet(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
    }

    /** Change event that is fired whenever the selected state of an option changes. */
    var MdcListSelectionChange = /** @class */ (function () {
        function MdcListSelectionChange(source) {
            this.source = source;
        }
        return MdcListSelectionChange;
    }());
    /**
     * Injection token used to provide the parent MdcList component to MdcListItem.
     */
    var MDC_LIST_PARENT_COMPONENT = new core.InjectionToken('MDC_LIST_PARENT_COMPONENT');
    var uniqueIdCounter = 0;
    var MdcListItemGraphic = /** @class */ (function () {
        function MdcListItemGraphic(elementRef) {
            this.elementRef = elementRef;
        }
        MdcListItemGraphic.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcListItemGraphic], mdc-list-item-graphic',
                        exportAs: 'mdcListItemGraphic',
                        host: {
                            'role': 'presentation',
                            'class': 'mdc-list-item__graphic',
                            '[attr.aria-hidden]': 'true'
                        }
                    },] }
        ];
        /** @nocollapse */
        MdcListItemGraphic.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        return MdcListItemGraphic;
    }());
    var MdcListItemMeta = /** @class */ (function () {
        function MdcListItemMeta(elementRef) {
            this.elementRef = elementRef;
        }
        MdcListItemMeta.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcListItemMeta], mdc-list-item-meta',
                        exportAs: 'mdcListItemMeta',
                        host: { 'class': 'mdc-list-item__meta' }
                    },] }
        ];
        /** @nocollapse */
        MdcListItemMeta.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        return MdcListItemMeta;
    }());
    var MdcListItemText = /** @class */ (function () {
        function MdcListItemText(elementRef) {
            this.elementRef = elementRef;
        }
        MdcListItemText.decorators = [
            { type: core.Component, args: [{
                        selector: '[mdcListItemText], mdc-list-item-text',
                        exportAs: 'mdcListItemText',
                        host: { 'class': 'mdc-list-item__text' },
                        template: "\n  <ng-container>\n    <span class=\"mdc-list-item__primary-text\"><ng-content></ng-content></span>\n    <span class=\"mdc-list-item__secondary-text\" *ngIf=\"secondaryText\">{{secondaryText}}</span>\n  </ng-container>",
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush
                    }] }
        ];
        /** @nocollapse */
        MdcListItemText.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        MdcListItemText.propDecorators = {
            secondaryText: [{ type: core.Input }]
        };
        return MdcListItemText;
    }());
    var MdcListItemSecondary = /** @class */ (function () {
        function MdcListItemSecondary(elementRef) {
            this.elementRef = elementRef;
        }
        MdcListItemSecondary.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcListItemSecondary], mdc-list-item-secondary',
                        exportAs: 'mdcListItemSecondary',
                        host: { 'class': 'mdc-list-item__secondary-text' }
                    },] }
        ];
        /** @nocollapse */
        MdcListItemSecondary.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        return MdcListItemSecondary;
    }());
    var MdcListItem = /** @class */ (function () {
        function MdcListItem(ripple, _changeDetectorRef, elementRef, _parent) {
            this.ripple = ripple;
            this._changeDetectorRef = _changeDetectorRef;
            this.elementRef = elementRef;
            this._parent = _parent;
            this._id = "mdc-list-item-" + uniqueIdCounter++;
            this.tabIndex = -1;
            this._selected = false;
            this._activated = false;
            this._disabled = false;
            this.selectionChange = new core.EventEmitter();
            this._root = this.elementRef.nativeElement;
            this.ripple = this._createRipple();
            this.ripple.init();
        }
        Object.defineProperty(MdcListItem.prototype, "id", {
            /** The unique ID of the list item. */
            get: function () {
                return this._id;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcListItem.prototype, "selected", {
            /** Whether the list item is selected. */
            get: function () {
                return this._selected;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._selected) {
                    this._selected = newValue;
                    this._changeDetectorRef.markForCheck();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcListItem.prototype, "activated", {
            /** Whether the list item is activated. */
            get: function () {
                return this._activated;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._activated) {
                    this._activated = newValue;
                    this._changeDetectorRef.markForCheck();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcListItem.prototype, "disabled", {
            /** Whether the list item is disabled. */
            get: function () {
                return this._disabled;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._disabled) {
                    this._disabled = newValue;
                    this._changeDetectorRef.markForCheck();
                }
            },
            enumerable: true,
            configurable: true
        });
        MdcListItem.prototype.ngOnDestroy = function () {
            this.ripple.destroy();
        };
        MdcListItem.prototype._createRipple = function () {
            var _this = this;
            var adapter = __assign(__assign({}, ripple$1.MdcRipple.createAdapter(this)), { isSurfaceDisabled: function () { return _this._disabled || _this._parent.disableRipple; } });
            return new ripple$1.MdcRipple(this.elementRef, new ripple.MDCRippleFoundation(adapter));
        };
        MdcListItem.prototype.focus = function () {
            this.getListItemElement().focus();
        };
        MdcListItem.prototype.setRole = function (role) {
            this.getListItemElement().setAttribute('role', role);
        };
        MdcListItem.prototype.getListItemElement = function () {
            return this.elementRef.nativeElement;
        };
        MdcListItem.prototype._onKeydown = function (evt) {
            if (evt.keyCode === keycodes.ENTER || evt.keyCode === keycodes.SPACE) {
                this._emitChangeEvent();
            }
        };
        /** Emits a change event if the selected state of an option changed. */
        MdcListItem.prototype._emitChangeEvent = function () {
            if (this._disabled) {
                return;
            }
            this.selectionChange.emit(new MdcListSelectionChange(this));
        };
        MdcListItem.decorators = [
            { type: core.Component, args: [{
                        selector: 'mdc-list-item, a[mdc-list-item]',
                        exportAs: 'mdcListItem',
                        host: {
                            'role': 'listitem',
                            '[id]': 'id',
                            '[tabIndex]': 'tabIndex',
                            'class': 'mdc-list-item',
                            '[attr.data-value]': 'value',
                            '[class.mdc-list-item--selected]': 'selected',
                            '[class.mdc-list-item--activated]': 'activated',
                            '[class.mdc-list-item--disabled]': 'disabled',
                            '(click)': '_emitChangeEvent()',
                            '(keydown)': '_onKeydown($event)'
                        },
                        template: '<ng-content></ng-content>',
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        providers: [ripple$1.MdcRipple]
                    }] }
        ];
        /** @nocollapse */
        MdcListItem.ctorParameters = function () { return [
            { type: ripple$1.MdcRipple },
            { type: core.ChangeDetectorRef },
            { type: core.ElementRef },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [MDC_LIST_PARENT_COMPONENT,] }] }
        ]; };
        MdcListItem.propDecorators = {
            value: [{ type: core.Input }],
            tabIndex: [{ type: core.Input }],
            selected: [{ type: core.Input }],
            activated: [{ type: core.Input }],
            disabled: [{ type: core.Input }],
            selectionChange: [{ type: core.Output }]
        };
        return MdcListItem;
    }());

    /** Change event that is being fired whenever the selected state of an option changes. */
    var MdcListItemChange = /** @class */ (function () {
        function MdcListItemChange(
        /** Reference to the selection list that emitted the event. */
        source, 
        /** Reference to the option that has been changed. */
        option) {
            this.source = source;
            this.option = option;
        }
        return MdcListItemChange;
    }());
    var MdcListGroup = /** @class */ (function () {
        function MdcListGroup(elementRef) {
            this.elementRef = elementRef;
        }
        MdcListGroup.decorators = [
            { type: core.Component, args: [{
                        selector: '[mdcListGroup], mdc-list-group',
                        exportAs: 'mdcListGroup',
                        host: { 'class': 'mdc-list-group' },
                        template: "\n  <h3 class=\"mdc-list-group__subheader\" *ngIf=\"subheader\">{{subheader}}</h3>\n  <ng-content></ng-content>",
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush
                    }] }
        ];
        /** @nocollapse */
        MdcListGroup.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        MdcListGroup.propDecorators = {
            subheader: [{ type: core.Input }]
        };
        return MdcListGroup;
    }());
    var MdcListGroupSubheader = /** @class */ (function () {
        function MdcListGroupSubheader(elementRef) {
            this.elementRef = elementRef;
        }
        MdcListGroupSubheader.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcListGroupSubheader], mdc-list-group-subheader',
                        exportAs: 'mdcListGroupSubheader',
                        host: { 'class': 'mdc-list-group__subheader' }
                    },] }
        ];
        /** @nocollapse */
        MdcListGroupSubheader.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        return MdcListGroupSubheader;
    }());
    var MdcList = /** @class */ (function (_super) {
        __extends(MdcList, _super);
        function MdcList(_platform, _changeDetectorRef, elementRef) {
            var _this = _super.call(this, elementRef) || this;
            _this._platform = _platform;
            _this._changeDetectorRef = _changeDetectorRef;
            _this.elementRef = elementRef;
            _this._twoLine = false;
            _this._dense = false;
            _this._border = false;
            _this._avatar = false;
            _this._interactive = true;
            _this._disableRipple = false;
            _this._useActivatedClass = false;
            _this._useSelectedClass = false;
            _this._verticalOrientation = true;
            _this._wrapFocus = false;
            /** Emits a change event whenever the selected state of an option changes. */
            _this.selectionChange = new core.EventEmitter();
            /** Emits an event for keyboard and mouse actions. */
            _this.actionEvent = new core.EventEmitter();
            /** Subscription to changes in list items. */
            _this._changeSubscription = null;
            /** Subscription to selection events in list items. */
            _this.itemSelectionSubscription = null;
            return _this;
        }
        Object.defineProperty(MdcList.prototype, "twoLine", {
            get: function () {
                return this._twoLine;
            },
            set: function (value) {
                this._twoLine = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcList.prototype, "dense", {
            get: function () {
                return this._dense;
            },
            set: function (value) {
                this._dense = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcList.prototype, "border", {
            get: function () {
                return this._border;
            },
            set: function (value) {
                this._border = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcList.prototype, "avatar", {
            get: function () {
                return this._avatar;
            },
            set: function (value) {
                this._avatar = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcList.prototype, "interactive", {
            get: function () {
                return this._interactive;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._interactive) {
                    this._interactive = newValue;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcList.prototype, "disableRipple", {
            get: function () {
                return this._disableRipple;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._disableRipple) {
                    this._disableRipple = newValue;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcList.prototype, "singleSelection", {
            get: function () {
                return this._singleSelection;
            },
            set: function (value) {
                if (value !== undefined) {
                    var newValue = coercion.coerceBooleanProperty(value);
                    if (newValue !== this._singleSelection) {
                        this._singleSelection = newValue;
                        this._foundation.setSingleSelection(this._singleSelection);
                        this._changeDetectorRef.markForCheck();
                    }
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcList.prototype, "useActivatedClass", {
            get: function () {
                return this._useActivatedClass;
            },
            set: function (value) {
                this._useActivatedClass = coercion.coerceBooleanProperty(value);
                this._foundation.setUseActivatedClass(this._useActivatedClass);
                this._changeDetectorRef.markForCheck();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcList.prototype, "useSelectedClass", {
            get: function () {
                return this._useSelectedClass;
            },
            set: function (value) {
                this._useSelectedClass = coercion.coerceBooleanProperty(value);
                this._changeDetectorRef.markForCheck();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcList.prototype, "verticalOrientation", {
            get: function () {
                return this._verticalOrientation;
            },
            set: function (value) {
                this._verticalOrientation = coercion.coerceBooleanProperty(value);
                this._foundation.setVerticalOrientation(this._verticalOrientation);
                this._changeDetectorRef.markForCheck();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcList.prototype, "wrapFocus", {
            get: function () {
                return this._wrapFocus;
            },
            set: function (value) {
                this._wrapFocus = coercion.coerceBooleanProperty(value);
                this._foundation.setWrapFocus(this._wrapFocus);
                this._changeDetectorRef.markForCheck();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcList.prototype, "listItemSelections", {
            /** Combined stream of all of the list item selection events. */
            get: function () {
                return rxjs.merge.apply(void 0, __spread(this.items.map(function (item) { return item.selectionChange; })));
            },
            enumerable: true,
            configurable: true
        });
        MdcList.prototype.getDefaultFoundation = function () {
            var _this = this;
            var adapter = {
                getListItemCount: function () { return _this.items.length; },
                getFocusedElementIndex: function () {
                    if (!_this._platform.isBrowser && document.activeElement) {
                        return -1;
                    }
                    return _this.items.toArray().findIndex(function (_) { return _.getListItemElement() === document.activeElement; }) || -1;
                },
                setAttributeForElementIndex: function (index, attr, value) {
                    var _a;
                    var item = _this.getListItemByIndex(index);
                    (_a = item === null || item === void 0 ? void 0 : item.getListItemElement()) === null || _a === void 0 ? void 0 : _a.setAttribute(attr, value);
                },
                addClassForElementIndex: function (index, className) {
                    return _this.items.toArray()[index].getListItemElement().classList.add(className);
                },
                removeClassForElementIndex: function (index, className) {
                    var _a, _b;
                    var item = _this.getListItemByIndex(index);
                    (_b = (_a = item === null || item === void 0 ? void 0 : item.getListItemElement()) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.remove(className);
                },
                getAttributeForElementIndex: function (index, attr) {
                    return _this.items.toArray()[index].getListItemElement().getAttribute(attr);
                },
                focusItemAtIndex: function (index) { return _this.focusItemAtIndex(index); },
                setTabIndexForListItemChildren: function (listItemIndex, tabIndexValue) {
                    var listItemChildren = [].slice.call(_this.items.toArray()[listItemIndex].getListItemElement()
                        .querySelectorAll(list.strings.CHILD_ELEMENTS_TO_TOGGLE_TABINDEX));
                    listItemChildren.forEach(function (ele) { return ele.setAttribute('tabindex', "" + tabIndexValue); });
                },
                hasCheckboxAtIndex: function (index) {
                    var listItem = _this.items.toArray()[index].getListItemElement();
                    return !!listItem.querySelector(list.strings.CHECKBOX_SELECTOR);
                },
                hasRadioAtIndex: function (index) {
                    var listItem = _this.items.toArray()[index].getListItemElement();
                    return !!listItem.querySelector(list.strings.RADIO_SELECTOR);
                },
                isCheckboxCheckedAtIndex: function (index) {
                    var listItem = _this.items.toArray()[index].getListItemElement();
                    var toggleEl = listItem.querySelector(list.strings.CHECKBOX_SELECTOR);
                    return toggleEl.checked;
                },
                setCheckedCheckboxOrRadioAtIndex: function (index, isChecked) {
                    var listItem = _this.items.toArray()[index].getListItemElement();
                    var toggleEl = listItem.querySelector(list.strings.CHECKBOX_RADIO_SELECTOR);
                    toggleEl.checked = isChecked;
                    if (_this._platform.isBrowser) {
                        var event_1 = document.createEvent('Event');
                        event_1.initEvent('change', true, true);
                        toggleEl.dispatchEvent(event_1);
                    }
                },
                isFocusInsideList: function () { return _this._platform.isBrowser ?
                    _this.elementRef.nativeElement.contains(document.activeElement) : false; },
                isRootFocused: function () { return _this._platform.isBrowser ? document.activeElement === _this._getHostElement() : false; },
                listItemAtIndexHasClass: function (index, className) {
                    return _this.items.toArray()[index].getListItemElement().classList.contains(className);
                },
                notifyAction: function (index) { return _this.actionEvent.emit({ index: index }); }
            };
            return new list.MDCListFoundation(adapter);
        };
        MdcList.prototype.ngAfterViewInit = function () {
            var _this = this;
            this._foundation.init();
            this._foundation.layout();
            // When list items change, re-subscribe
            this._changeSubscription = this.items.changes.pipe(operators.startWith(null))
                .subscribe(function () {
                if (_this.items.length) {
                    _this._resetListItems();
                }
            });
        };
        MdcList.prototype.ngOnDestroy = function () {
            var _a;
            this._dropSubscriptions();
            (_a = this._changeSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
            this._foundation.destroy();
        };
        MdcList.prototype.setSelectedIndex = function (index) {
            this.reset();
            this._foundation.setSelectedIndex(index);
            if (index === -1) {
                return;
            }
            var selectedItem = this.items.toArray()[index];
            if (selectedItem) {
                this._applySelectionState(selectedItem);
            }
        };
        MdcList.prototype.setSelectedValue = function (value) {
            this.reset();
            if (value === null) {
                return;
            }
            var selectedItem = this.getListItemByValue(value);
            this._foundation.setSelectedIndex(this.getListItemIndexByValue(value));
            if (selectedItem) {
                this._applySelectionState(selectedItem);
            }
        };
        MdcList.prototype.getSelectedItem = function () {
            return this.items.toArray().find(function (_) { return _.selected || _.activated; });
        };
        MdcList.prototype.getSelectedIndex = function () {
            return this.items.toArray().findIndex(function (_) { return _.selected || _.activated; });
        };
        MdcList.prototype.getSelectedValue = function () {
            var item = this.items ? this.items.find(function (_) { return _.selected; }) : null;
            return item && item.value ? item.value : null;
        };
        MdcList.prototype.getSelectedText = function () {
            var selectedItem = this.getSelectedItem();
            return selectedItem && selectedItem.getListItemElement().textContent || '';
        };
        MdcList.prototype.getListItemByValue = function (value) {
            return this.items.toArray().find(function (_) { return _.value === value; });
        };
        MdcList.prototype.getListItemByIndex = function (index) {
            return this.items.toArray()[index];
        };
        MdcList.prototype.getListItemIndexByValue = function (value) {
            return this.items.toArray().findIndex(function (_) { return _.value === value; });
        };
        MdcList.prototype.focusItemAtIndex = function (index) {
            this.items.toArray()[index].getListItemElement().focus();
        };
        MdcList.prototype.focusFirstElement = function () {
            return this._foundation.focusFirstElement();
        };
        MdcList.prototype.focusLastElement = function () {
            return this._foundation.focusLastElement();
        };
        MdcList.prototype.focusNextElement = function (index) {
            return this._foundation.focusNextElement(index);
        };
        MdcList.prototype.focusPrevElement = function (index) {
            return this._foundation.focusPrevElement(index);
        };
        MdcList.prototype.setRole = function (role) {
            this._getHostElement().setAttribute('role', role);
        };
        MdcList.prototype.setTabIndex = function (index) {
            this._getHostElement().tabIndex = index;
        };
        MdcList.prototype.focus = function () {
            this._getHostElement().focus();
        };
        MdcList.prototype.reset = function () {
            this.items.forEach(function (_) {
                _.selected = false;
                _.activated = false;
            });
        };
        MdcList.prototype._applySelectionState = function (item) {
            if (this.useActivatedClass) {
                item.activated = true;
            }
            else if (this.useSelectedClass) {
                item.selected = true;
            }
        };
        MdcList.prototype._resetListItems = function () {
            this._dropSubscriptions();
            this._listenForListItemSelection();
        };
        MdcList.prototype._dropSubscriptions = function () {
            if (this.itemSelectionSubscription) {
                this.itemSelectionSubscription.unsubscribe();
                this.itemSelectionSubscription = null;
            }
        };
        /** Listens to selected events on each list item. */
        MdcList.prototype._listenForListItemSelection = function () {
            var _this = this;
            this.itemSelectionSubscription = this.listItemSelections.subscribe(function (event) {
                if (_this.singleSelection) {
                    _this.items.filter(function (_) { return _.id !== event.source.id && (_.activated || _.selected); })
                        .forEach(function (_) {
                        _.selected = false;
                        _.activated = false;
                    });
                }
                _this._applySelectionState(event.source);
                if (!_this.singleSelection) {
                    event.source.ripple.handleBlur();
                }
                _this.selectionChange.emit(new MdcListItemChange(_this, event.source));
            });
        };
        MdcList.prototype._onFocusIn = function (evt) {
            var index = this._getListItemIndexByEvent(evt);
            this._foundation.handleFocusIn(evt, index);
        };
        MdcList.prototype._onFocusOut = function (evt) {
            var index = this._getListItemIndexByEvent(evt);
            if (index >= 0) {
                this._foundation.handleFocusOut(evt, index);
            }
        };
        MdcList.prototype._onKeydown = function (evt) {
            var index = this._getListItemIndexByEvent(evt);
            var target = evt.target;
            if (index >= 0) {
                this._foundation.handleKeydown(evt, target.classList.contains(list.cssClasses.LIST_ITEM_CLASS), index);
            }
        };
        MdcList.prototype._handleClickEvent = function (evt) {
            var index = this._getListItemIndexByEvent(evt);
            var target = evt.target;
            var listItem = this._getListItemByEventTarget(evt.target);
            if (listItem && listItem.disabled) {
                return;
            }
            // Toggle the checkbox only if it's not the target of the event, or the checkbox will have 2 change events.
            var toggleCheckbox = !dom.matches(target, list.strings.CHECKBOX_RADIO_SELECTOR);
            this._foundation.handleClick(index, toggleCheckbox);
        };
        MdcList.prototype._getListItemByEventTarget = function (target) {
            return this.items.toArray().find(function (_) { return _.getListItemElement() === target; });
        };
        MdcList.prototype._getListItemIndexByEvent = function (evt) {
            return this.items.toArray().findIndex(function (_) { return _.getListItemElement() === evt.target; });
        };
        /** Retrieves the DOM element of the component host. */
        MdcList.prototype._getHostElement = function () {
            return this.elementRef.nativeElement;
        };
        MdcList.decorators = [
            { type: core.Component, args: [{
                        selector: 'mdc-list',
                        exportAs: 'mdcList',
                        host: {
                            'role': 'list',
                            'class': 'mdc-list',
                            '[attr.aria-orientation]': 'verticalOrientation ? "vertical" : "horizontal"',
                            '[class.mdc-list--dense]': 'dense',
                            '[class.mdc-list--avatar-list]': 'avatar',
                            '[class.ngx-mdc-list--border]': 'border',
                            '[class.mdc-list--non-interactive]': '!interactive',
                            '[class.mdc-list--two-line]': 'twoLine',
                            '(click)': '_handleClickEvent($event)',
                            '(keydown)': '_onKeydown($event)',
                            '(focusin)': '_onFocusIn($event)',
                            '(focusout)': '_onFocusOut($event)'
                        },
                        template: '<ng-content></ng-content>',
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        providers: [{ provide: MDC_LIST_PARENT_COMPONENT, useExisting: MdcList }]
                    }] }
        ];
        /** @nocollapse */
        MdcList.ctorParameters = function () { return [
            { type: platform.Platform },
            { type: core.ChangeDetectorRef },
            { type: core.ElementRef }
        ]; };
        MdcList.propDecorators = {
            twoLine: [{ type: core.Input }],
            dense: [{ type: core.Input }],
            border: [{ type: core.Input }],
            avatar: [{ type: core.Input }],
            interactive: [{ type: core.Input }],
            disableRipple: [{ type: core.Input }],
            singleSelection: [{ type: core.Input }],
            useActivatedClass: [{ type: core.Input }],
            useSelectedClass: [{ type: core.Input }],
            verticalOrientation: [{ type: core.Input }],
            wrapFocus: [{ type: core.Input }],
            items: [{ type: core.ContentChildren, args: [MdcListItem, { descendants: true },] }],
            selectionChange: [{ type: core.Output }],
            actionEvent: [{ type: core.Output }]
        };
        return MdcList;
    }(base.MDCComponent));

    var LIST_DECLARATIONS = [
        MdcList,
        MdcListDivider,
        MdcListGroup,
        MdcListGroupSubheader,
        MdcListItem,
        MdcListItemGraphic,
        MdcListItemMeta,
        MdcListItemSecondary,
        MdcListItemText
    ];
    var MdcListModule = /** @class */ (function () {
        function MdcListModule() {
        }
        MdcListModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [common.CommonModule],
                        exports: LIST_DECLARATIONS,
                        declarations: LIST_DECLARATIONS,
                    },] }
        ];
        return MdcListModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    exports.MDC_LIST_PARENT_COMPONENT = MDC_LIST_PARENT_COMPONENT;
    exports.MdcList = MdcList;
    exports.MdcListDivider = MdcListDivider;
    exports.MdcListGroup = MdcListGroup;
    exports.MdcListGroupSubheader = MdcListGroupSubheader;
    exports.MdcListItem = MdcListItem;
    exports.MdcListItemChange = MdcListItemChange;
    exports.MdcListItemGraphic = MdcListItemGraphic;
    exports.MdcListItemMeta = MdcListItemMeta;
    exports.MdcListItemSecondary = MdcListItemSecondary;
    exports.MdcListItemText = MdcListItemText;
    exports.MdcListModule = MdcListModule;
    exports.MdcListSelectionChange = MdcListSelectionChange;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=web-list.umd.js.map
